var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayTts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 0C13.3971 0 10.1683 0.979438 7.42198 2.81446C4.67568 4.64948 2.5352 7.25766 1.27122 10.3092C0.00723588 13.3607 -0.32348 16.7185 0.320893 19.958C0.965266 23.1975 2.55579 26.1731 4.89132 28.5087C7.22686 30.8442 10.2025 32.4347 13.442 33.0791C16.6815 33.7235 20.0393 33.3928 23.0908 32.1288C26.1423 30.8648 28.7505 28.7243 30.5856 25.978C32.4206 23.2317 33.4 20.0029 33.4 16.7C33.395 12.2724 31.6339 8.02764 28.5031 4.89687C25.3724 1.7661 21.1276 0.00502878 16.7 0Z",
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2525 16.8786L11.2015 26.1466C11.1701 26.165 11.1344 26.1747 11.098 26.1747C11.0617 26.1747 11.0259 26.165 10.9945 26.1466C10.9637 26.1281 10.9382 26.1019 10.9207 26.0705C10.9031 26.0391 10.8941 26.0036 10.8945 25.9676V7.43163C10.8945 7.39525 10.9041 7.3595 10.9223 7.328C10.9406 7.2965 10.9667 7.27035 10.9983 7.2522C11.0298 7.23405 11.0656 7.22453 11.102 7.22461C11.1384 7.22469 11.1741 7.23435 11.2055 7.25263L27.2525 16.5196C27.2841 16.5378 27.3104 16.5639 27.3286 16.5954C27.3468 16.6269 27.3564 16.6627 27.3564 16.6991C27.3564 16.7355 27.3468 16.7713 27.3286 16.8028C27.3104 16.8343 27.2841 16.8605 27.2525 16.8786Z",
    fill: "#316BF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayTts);
export default __webpack_public_path__ + "static/media/play-tts.25b5ef739f7c492388a68b5a7f3f5cce.svg";
export { ForwardRef as ReactComponent };